import React from 'react';

function NavbarFooter() {
  return (
    <div>
      <footer style={{ backgroundColor: "#014255", height: "65px", position: 'fixed', width: "100%", bottom: "0", left: "0" }}>
        <div style={{ float: "left", marginRight: "50px" }}>
          <ul style={{ padding: "0px 0px 0px 10px" }}>
            <li style={{ color: "white", display: "inline", margin: "0px 10px 0px 10px" }}>
              <a href='http://localhost:3000/' title='home' style={{ color: "white", listStyle: "none", fontSize: "15px" }}>Home</a>
            </li>
            <span style={{ color: "white" }}>|</span>
            <li style={{ color: "white", display: "inline", margin: "0px 10px 0px 10px" }}>
              <a href='faq' title='home' style={{ color: "white", listStyle: "none", fontSize: "15px" }}>FAQ </a>
            </li>
            <span style={{ color: "white" }}>|</span>
            <li style={{ color: "white", display: "inline", margin: "0px 10px 0px 10px" }}>
              <a href='http://localhost:3000/contactus' title='home' style={{ color: "white", listStyle: "none", fontSize: "15px" }}>Contact Us </a>
            </li>
            <li style={{ color: "white", marginLeft: "10px", marginTop: "5px", listStyle: "none", fontSize: "13px" }}>
              2017 © Urban Development Department. All Rights Reserved.
            </li>
          </ul>
        </div>
        <div style={{ float: "right", width: "50%", color: "white", margin: "20px 70px 0px 0px", textAlign: "right" }}>
          <div>
            <span>Total Visitors :-<strong>223367</strong> </span>
          </div>
          <div style={{ float: "right", color: "white", margin: "0px 0px 10px 0px", textAlign: "right", fontSize: "14px" }}>
            Powered By <span style={{ color: "skyblue" }}>ABM Knowedgeware Limited</span>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default NavbarFooter;
